<template>
  <div class="main-content">
    <div class="row mb-3">
      <div
        class="col-md-12"
        v-if="!filters.central_id || filters.central_id.length === 0"
      >
        <div class="alert alert-warning" role="alert">
          <strong>Atenção:</strong> Selecione uma agência para filtrar por
          convênio.
        </div>
      </div>
      <div class="col-md-2 mt-2">
        <label>Nº Ocorrência</label>
        <input type="text" class="form-control" v-model="filters.external_id" />
      </div>

      <div class="col-md-2 mt-2">
        <label for="flagUnitSelect">Agência:</label>
        <v-select
          v-model="filters.central_id"
          :options="centrals"
          :reduce="(central) => central.id"
          label="fantasy_name"
          multiple
          placeholder="Exibir Todos"
          @input="getMedicals"
        ></v-select>
      </div>
      <div class="col-md-2 mt-2">
        <label for="flagUnitSelect">Serviço:</label>
        <v-select
          v-model="filters.occurrence_type"
          :options="[{ value: 'APH', label: 'APH' }]"
          :reduce="(option) => option.value"
          label="label"
          multiple
          placeholder="Exibir APH"
        ></v-select>
      </div>
      <div class="col-md-3 mt-2">
        <label>Data Inicial</label>
        <input
          type="date"
          class="form-control"
          v-model="filters.opening_date"
          :max="filters.end_date || null"
        />
      </div>
      <div class="col-md-3 mt-2">
        <label>Data Final</label>
        <input
          type="date"
          class="form-control"
          v-model="filters.end_date"
          :min="filters.opening_date || null"
        />
      </div>
      <div
        class="col-md-2 mt-2"
        v-if="filters.central_id && filters.central_id.length > 0"
      >
        <label for="flagUnitSelect">Convênio:</label>
        <v-select
          v-model="filters.health_plan"
          :options="plans"
          :reduce="(plan) => plan.id"
          label="title"
          multiple
          placeholder="Exibir Todos"
        ></v-select>
      </div>
      <div class="col-md-4 mt-2">
        <label for="Cellphone">Unidade:</label>
        <v-select
          v-model="filters.origin"
          :options="filteredUnits"
          :reduce="(unit) => unit.id"
          label="unit_name"
          multiple
          placeholder="Exibir Todos"
        ></v-select>
      </div>
      <div class="col-md-4 mt-2">
        <label>Vitima</label>
        <input type="text" class="form-control" v-model="filters.name" />
      </div>
      <div class="row mt-3">
        <div class="col-md-12">
          <button class="btn btn-primary" @click="getOccurrences">
            Filtrar
          </button>
          <button
            class="col-md-8 ml-1 btn btn-success text-content-right"
            data-toggle="modal"
            data-target="#modalExport"
          >
            Exportar Ocorrências em Excel
          </button>
        </div>
      </div>
    </div>
    <div class="ibox-title" style="padding: 16px">
      <h3>Finalizados</h3>
      <div
        class="modal fade"
        id="modalExport"
        tabindex="-1"
        role="dialog"
        aria-labelledby="modalExportTitle"
        aria-hidden="true"
      >
        <div
          class="modal-dialog modal-dialog-centered modal-xl"
          role="document"
        >
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLongTitle">Exportar</h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div class="modal-body mt-1">
              <div
                class="alert alert-warning"
                role="alert"
                v-if="!filters.start_date && !filters.end_date_f"
              >
                Para exportar todos os registros de finalizados, basta não
                definir nenhum intervalo de datas e proceder com a exportação.
                <button
                  type="button"
                  class="close"
                  data-dismiss="alert"
                  aria-label="Close"
                ></button>
              </div>

              <div class="d-flex justify-content-between">
                <div class="col-md-3 mb-1">
                  <label for="Cellphone">Unidade:</label>
                  <v-select
                    v-model="filters.unit_id"
                    :options="filteredUnits"
                    :reduce="(unit) => unit.id"
                    label="unit_name"
                    multiple
                    placeholder="Exibir Todos"
                  ></v-select>
                </div>
                <div class="col-md-3 mb-1">
                  <label for="flagUnitSelect">Agência:</label>
                  <v-select
                    v-model="filters.central_id"
                    :options="centrals"
                    :reduce="(central) => central.id"
                    label="fantasy_name"
                    multiple
                    placeholder="Exibir Todos"
                  ></v-select>
                </div>
                <div class="col-md-3 mb-1">
                  <label>Data de Ínicio</label>
                  <input
                    type="date"
                    class="form-control"
                    v-model="filters.start_date"
                    :max="filters.end_date_f || null"
                  />
                </div>
                <div class="col-md-3 mb-1">
                  <label>Data do Fim</label>
                  <input
                    type="date"
                    class="form-control"
                    v-model="filters.end_date_f"
                    :min="filters.start_date || null"
                  />
                </div>
              </div>
            </div>

            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                Fechar
              </button>
              <button
                type="button"
                class="btn btn-primary"
                @click="exportToExcel"
                :disabled="exporting"
              >
                {{ exporting ? "Gerando…" : "Exportar" }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card p-1">
          <div class="table-responsive">
            <table class="table table-bordered table-hover table-sm">
              <thead>
                <tr>
                  <th></th>
                  <th>Nº Ocorrência</th>
                  <th>Data Abertura</th>
                  <th>Nome</th>
                  <th>Idade</th>
                  <th>Convênio</th>
                  <th>Queixa</th>
                  <th>Tipo</th>
                  <th>Motivo</th>
                  <th>Bairro</th>
                  <th>Município</th>
                  <th>Veiculo</th>
                  <th>Unidade (Destino)</th>
                  <!-- <th>Sexo</th> -->
                  <!-- <th>Data Previsão Chegada (Destino)</th>
                  <th>Chegada á Unidade (Destino)</th> -->
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="occurrence in occurrences" :key="occurrence.id">
                  <td>
                    <span :title="occurrence.classification">
                      {{ occurrence.classification_f }}
                    </span>
                  </td>
                  <td>{{ occurrence.external_id }}</td>
                  <td>{{ occurrence.opening_date_h }}</td>
                  <td>{{ occurrence.people ? occurrence.people.name : "" }}</td>
                  <td>{{ occurrence.people ? occurrence.people.age : "" }}</td>

                  <td>{{ occurrence.plan ? occurrence.plan.title : "" }}</td>
                  <td>
                    {{ occurrence.description ? occurrence.description : "" }}
                  </td>
                  <td>{{ occurrence.type ? occurrence.type.title : (occurrence.central_id == 7 ? occurrence.occurrence_type_external : "") }}</td>
                  <td>
                    {{ occurrence.reason ? occurrence.reason.title : (occurrence.central_id == 7 ? occurrence.complaint : "") }}
                  </td>
                  <td>
                    {{
                      occurrence.people ? occurrence.people.neighborhood : ""
                    }}
                  </td>
                  <td>{{ occurrence.people ? occurrence.people.city : "" }}</td>
                  <!-- <td v-if="occurrence.central_id == 7">
                    {{ occurrence.team ? occurrence.team.name : occurrence.vehicle }}
                  </td> -->
                  <td>
                    {{ occurrence.vehicle ? occurrence.vehicle : "" }}
                  </td>
                  <td>
                    {{ occurrence.unit ? occurrence.unit.unit_name : "" }}
                  </td>

                  <!-- <td>
                    {{ occurrence.people ? occurrence.people.gender : "" }}
                  </td> -->
                  <!-- <td>{{ occurrence.estimated_arrival_f }}</td>
                  <td>{{ occurrence.arrival_at_unit_f }}</td> -->

                  <td class="text-center align-middle">
                    <div
                      class="d-flex justify-content-center align-items-center"
                      style="gap: 4px"
                    >
                      <button
                        type="button"
                        class="btn btn-outline-primary btn-sm d-flex align-items-center"
                        @click="openModal(occurrence.id)"
                        title="Ver detalhes"
                      >
                        <i class="fas fa-eye"></i>
                      </button>
                      <button
                        v-if="canEditOutcome"
                        type="button"
                        class="btn btn-outline-primary btn-sm d-flex align-items-center"
                        @click="openOutcomePanel(occurrence)"
                        title="Editar Desfecho"
                      >
                        <feather-icon icon="Edit2Icon" />
                      </button>
                      <a
                        :href="
                          occurrence.agency.flag_record === 1
                            ? occurrence.url_record
                            : occurrence.url
                        "
                        target="_blank"
                        class="btn btn-outline-primary btn-sm d-flex align-items-center"
                        title="Ver ficha"
                      >
                        <feather-icon icon="FileTextIcon" />
                      </a>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div
            class="col-md-6 mt-1 mx-auto d-flex justify-content-center align-items-center"
          >
            <pagination
              :records="total"
              :options="options"
              :per-page="15"
              @paginate="getOccurrences"
            ></pagination>
          </div>
          <!-- Modal Infos -->
          <b-modal
            id="modalInfo"
            title="Informações"
            centered
            size="xl"
            dialog-class="modal-xxl"
          >
            <div v-if="occurrenceSelected">
              <div class="table-responsive">
                <table class="table table-striped text-center">
                  <thead>
                    <tr>
                      <th>Agência</th>
                      <th>Serviço</th>
                      <th>Nº Ocorrência</th>
                      <th>Data Abertura</th>
                      <th>Nome</th>
                      <th>Idade</th>
                      <th>Queixa</th>
                      <th>Tipo</th>
                      <th>Motivo</th>
                      <th>Bairro</th>
                      <th>Município</th>
                      <th>Veículo</th>
                      <th>Unidade (Destino)</th>
                      <th>Convênio</th>
                      <th>Saída do local</th>
                      <th>Chegada à Unidade (Destino)</th>
                      <th>Saída da Unidade</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        {{
                          occurrenceSelected.agency
                            ? occurrenceSelected.agency.fantasy_name
                            : ""
                        }}
                      </td>
                      <td>{{ occurrenceSelected.occurrence_type }}</td>
                      <td>{{ occurrenceSelected.external_id }}</td>
                      <td>{{ occurrenceSelected.opening_date_h }}</td>
                      <td>
                        {{
                          occurrenceSelected.people
                            ? occurrenceSelected.people.name
                            : ""
                        }}
                      </td>
                      <td>
                        {{
                          occurrenceSelected.people
                            ? occurrenceSelected.people.age
                            : ""
                        }}
                      </td>
                      <td>{{ occurrenceSelected.complaint }}</td>
                      <td>
                        {{
                          occurrenceSelected.type
                            ? occurrenceSelected.type.title
                            : (occurrenceSelected.central_id == 7 ? occurrenceSelected.occurrence_type_external : "")
                        }}
                      </td>
                      <td>
                        {{
                          occurrenceSelected.reason
                            ? occurrenceSelected.reason.title
                            : (occurrenceSelected.central_id == 7 ? occurrenceSelected.complaint : "")
                        }}
                      </td>
                      <td>{{ occurrenceSelected.people.neighborhood }}</td>
                      <td>{{ occurrenceSelected.people ? occurrenceSelected.people.city : "" }}</td>
                      <td>{{ occurrenceSelected.vehicle }}</td>
                      <td>
                        {{
                          occurrenceSelected.unit
                            ? occurrenceSelected.unit.unit_name
                            : ""
                        }}
                      </td>
                      <td>
                        {{
                          occurrenceSelected.plan
                            ? occurrenceSelected.plan.title
                            : ""
                        }}
                      </td>
                      <td>
                        {{
                          occurrenceSelected.departure_from_unit
                            ? occurrenceSelected.departure_from_unit_f
                            : "Não informado"
                        }}
                      </td>
                      <td>
                        {{
                          occurrenceSelected.arrival_at_unit
                            ? occurrenceSelected.arrival_at_unit_f
                            : "Não informado"
                        }}
                      </td>
                      <td>
                        {{
                          occurrenceSelected.output_unit
                            ? occurrenceSelected.output_unit_f
                            : "Não informado"
                        }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <!-- Seção de Desfecho -->
            <div v-if="occurrenceSelected" class="mt-4">
              <hr />
              <h6 class="mb-2 font-weight-bold">Desfecho</h6>
              <div class="row">
                <div class="col-md-2">
                  <small class="text-muted d-block">Internação</small>
                  <span>{{
                    occurrenceSelected.outcome
                      ? formatBool(occurrenceSelected.outcome.hospitalization)
                      : "—"
                  }}</span>
                </div>
                <div class="col-md-2">
                  <small class="text-muted d-block">UTI</small>
                  <span>{{
                    occurrenceSelected.outcome
                      ? formatBool(occurrenceSelected.outcome.uti)
                      : "—"
                  }}</span>
                </div>
                <div class="col-md-2">
                  <small class="text-muted d-block">Cirurgia</small>
                  <span>{{
                    occurrenceSelected.outcome
                      ? formatBool(occurrenceSelected.outcome.surgery)
                      : "—"
                  }}</span>
                </div>
                <div class="col-md-3">
                  <small class="text-muted d-block">CID-10</small>
                  <span
                    v-if="
                      occurrenceSelected.outcome &&
                      occurrenceSelected.outcome.cid_code
                    "
                  >
                    <strong>{{ occurrenceSelected.outcome.cid_code }}</strong> —
                    {{ occurrenceSelected.outcome.cid_description }}
                  </span>
                  <span v-else>—</span>
                </div>
                <div class="col-md-3">
                  <small class="text-muted d-block">Status / Desfecho</small>
                  <span>{{
                    occurrenceSelected.outcome &&
                    occurrenceSelected.outcome.outcome_status
                      ? occurrenceSelected.outcome.outcome_status
                      : "—"
                  }}</span>
                </div>
                <div
                  class="col-md-12 mt-2"
                  v-if="
                    occurrenceSelected.outcome &&
                    occurrenceSelected.outcome.observation
                  "
                >
                  <small class="text-muted d-block">Observação</small>
                  <span style="white-space: pre-wrap">{{
                    occurrenceSelected.outcome.observation
                  }}</span>
                </div>
              </div>
            </div>

            <div v-if="!occurrenceSelected">Carregando...</div>

            <template #modal-footer>
              <b-button variant="secondary" @click="closeModal"
                >Fechar</b-button
              >
            </template>
          </b-modal>
        </div>
      </div>
    </div>

    <occurrence-outcome-modal
      ref="outcomeModal"
      :occurrence="selectedOutcomeOccurrence"
      @saved="onOutcomeSaved"
    />
  </div>
</template>

<script>
import { Pagination } from "vue-pagination-2";
import {
  BLink,
  BNavbarNav,
  BNavItemDropdown,
  BDropdownItem,
  BDropdownDivider,
  BAvatar,
  BButton,
  BModal,
} from "bootstrap-vue";
import OccurrenceOutcomeModal from "./OccurrenceOutcomeModal.vue";

export default {
  data() {
    // Calcula as datas padrão
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);

    // Formata as datas no formato YYYY-MM-DD
    const formatDate = (date) => {
      return date.toISOString().split("T")[0];
    };

    return {
      filters: {
        central_id: [],
        health_plan: [],
        occurrence_type: ["APH"],
        unit_id: [],
        opening_date: formatDate(yesterday), // Data de ontem
        end_date: formatDate(today), // Data de hoje
        external_id: "",
        origin: [],
        name: "",
        start_date: "",
        end_date_f: "",
      },
      occurrences: [],
      options: {
        texts: {
          count: "Mostrando {from} de {to} até {count} de registros",
        },
        chunk: 4,
        chunksNavigation: "fixed",
      },
      total: 0,
      page: 1,
      pages: [],
      selectedOccurrenceId: 2203190496,
      units: [],
      occurrenceSelectedId: null,
      occurrenceSelected: null,
      selectedOutcomeOccurrence: null,
      centrals: [],
      plans: [],
      exporting: false,
      currentExportId: null,
      exportPoll: null,
    };
  },
  components: {
    Pagination,
    BLink,
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
    BButton,
    BModal,
    OccurrenceOutcomeModal,
  },
  watch: {
    selectedOccurrenceId: {
      handler(val) {
        if (val) {
          console.log("entrou", val);
          window.Echo.private("new_status." + val).listen(".Status", (e) => {
            console.log("ewerwerwerwe", val);
            const index = this.occurrences.findIndex(
              (o) => o.external_id === e.occurrence.external_id
            );
            console.log("entrou2", val);
            this.occurrences[index].status = e.occurrence.status;
          });
        }
      },
      immediate: true,
    },
    "filters.central_id"() {
      this.getUnits(); // Recarrega unidades quando central muda
    },
  },
  computed: {
    canEditOutcome() {
      return [2, 3, 6].includes(this.$store.state.user.access_nivel);
    },
    filteredUnits() {
      const allOption = [{ id: null, unit_name: "Exibir Todos" }];
      return allOption.concat(this.units);
    },
  },
  methods: {
    // Valida intervalo: Data Final >= Data Inicial. ('YYYY-MM-DD' -> comparação de string)
    datesValid(ini, fim) {
      if (ini && fim && fim < ini) {
        swal(
          "Datas inválidas",
          "A Data Final deve ser maior ou igual à Data Inicial.",
          "warning"
        );
        return false;
      }
      return true;
    },
    exportToExcel() {
      const self = this;
      const startDate = self.filters.start_date;
      const endDate = self.filters.end_date_f;

      // RN08g: não permitir exportar com intervalo PARCIAL (só uma das datas).
      // Regra: as duas datas preenchidas OU as duas em branco (exporta tudo).
      if ((startDate && !endDate) || (!startDate && endDate)) {
        swal(
          "Datas incompletas",
          "Preencha as duas datas do período ou deixe ambas em branco.",
          "warning"
        );
        return;
      }
      // RN08f / RN08j: Data do Fim não pode ser anterior à Data de Início.
      if (!self.datesValid(startDate, endDate)) return;

      const centralId = self.filters.central_id;
      const unitId = self.filters.unit_id;
      const userId = self.$store.state.user.usuario_id;
      const nivel = self.$store.state.user.access_nivel;

      // Usuário restrito precisa informar a unidade.
      if (nivel != 6 && nivel != 2 && (!unitId || unitId.length === 0)) {
        self.$message(
          null,
          "Por favor, preencha a unidade para filtrar.",
          "error"
        );
        return;
      }

      // Monta os filtros (as duas datas ou nenhuma; vazio = exporta tudo).
      const filters = { user_id: userId };
      if (centralId && centralId.length > 0) filters.central_id = centralId;
      if (unitId && unitId.length > 0) filters.unit_id = unitId;
      if (startDate && endDate) {
        filters.start_date = startDate;
        filters.end_date = `${endDate} 23:59:59`;
      }

      self.exporting = true;
      if (self.$message)
        self.$message(
          "Gerando",
          "Gerando o arquivo… você será avisado quando ficar pronto.",
          "info"
        );

      axios
        .post(self.$store.state.api + "exports", { type: "finished", filters })
        .then((res) => {
          self.currentExportId = res.data.export.id;
          self.startExportPolling(self.currentExportId);
        })
        .catch(() => {
          self.exporting = false;
          if (self.$message)
            self.$message(
              null,
              "Não foi possível iniciar a exportação.",
              "error"
            );
        });
    },

    // Aviso em tempo real (Reverb): dispara quando o job termina.
    onExportReady(e) {
      if (!e || e.id !== this.currentExportId) return;
      if (e.status === "done") this.finishExport(e);
      else this.failExport();
    },

    // Fallback caso o websocket não chegue: consulta o status a cada 5s.
    startExportPolling(id) {
      const self = this;
      this.stopExportPolling();
      this.exportPoll = setInterval(() => {
        axios
          .get(self.$store.state.api + "exports/" + id)
          .then((res) => {
            if (res.data.status === "done") self.finishExport(res.data);
            else if (res.data.status === "failed") self.failExport();
          })
          .catch(() => {});
      }, 5000);
    },

    stopExportPolling() {
      if (this.exportPoll) {
        clearInterval(this.exportPoll);
        this.exportPoll = null;
      }
    },

    // Idempotente: Reverb e polling podem chegar quase juntos.
    finishExport(exp) {
      if (!this.exporting) return;
      this.exporting = false;
      this.currentExportId = null;
      this.stopExportPolling();
      this.downloadReady(exp);
    },

    failExport() {
      if (!this.exporting) return;
      this.exporting = false;
      this.currentExportId = null;
      this.stopExportPolling();
      if (this.$message)
        this.$message(null, "Falha ao gerar o arquivo.", "error");
    },

    // A rota de download é autenticada (JWT) -> baixa via blob, não window.open.
    downloadReady(exp) {
      const self = this;
      axios
        .get(self.$store.state.api + "exports/" + exp.id + "/download", {
          responseType: "blob",
        })
        .then((res) => {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const a = document.createElement("a");
          a.href = url;
          a.download = exp.file_name || "finalizados.csv";
          document.body.appendChild(a);
          a.click();
          a.remove();
          window.URL.revokeObjectURL(url);
          if (self.$message)
            self.$message("Pronto", "Seu arquivo foi baixado.", "success");
        })
        .catch(() => {
          if (self.$message)
            self.$message(
              null,
              "Arquivo pronto, mas o download falhou.",
              "error"
            );
        });
    },

    openModal(occurrenceId) {
      this.occurrenceSelected = this.occurrences.find(
        (o) => o.id === occurrenceId
      );
      this.$bvModal.show("modalInfo");
    },
    closeModal() {
      this.$bvModal.hide("modalInfo");
    },
    getOccurrences(page) {
      const self = this;
      // RN08f / RN08j: bloqueia filtrar com Data Final anterior à Data Inicial.
      if (!self.datesValid(self.filters.opening_date, self.filters.end_date)) return;
      self.page = page || 1;

      const api =
        self.$store.state.api + "occurrences_finished?page=" + self.page;

      self.$loading(true);
      axios
        .post(api, self.filters)
        .then((response) => {
          self.occurrences = response.data.data;
          self.total = response.data.total;

          self.$loading(false);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
          self.$loading(false);
        });
    },
    getUnits: function () {
      const self = this;
      let api = self.$store.state.api + "units/filter-by-central";

      if (self.filters.central_id) {
        api += `?central_ids=${self.filters.central_id}`;
      }

      axios
        .get(api)
        .then((response) => {
          self.units = response.data.data.sort((a, b) =>
            a.unit_name.localeCompare(b.unit_name)
          );
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },

    getMedicals: function () {
      const self = this;
      let api = self.$store.state.api + "medical-agreements?paginated=false";

      if (self.filters.central_id && self.filters.central_id.length > 0) {
        api += `&central_id=${self.filters.central_id.join(",")}`;
      }

      axios
        .get(api)
        .then((response) => {
          // Filtrar duplicatas por title (exibir apenas o primeiro de cada)
          const uniquePlans = response.data.data.filter(
            (plan, index, self) =>
              index === self.findIndex((p) => p.title === plan.title)
          );
          self.plans = uniquePlans.sort((a, b) =>
            a.title.localeCompare(b.title)
          );
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    openOutcomePanel(occurrence) {
      this.selectedOutcomeOccurrence = occurrence;
      this.$nextTick(() => {
        this.$refs.outcomeModal.open();
      });
    },
    onOutcomeSaved() {
      const self = this;
      const api =
        self.$store.state.api +
        "occurrence-outcomes/" +
        self.selectedOutcomeOccurrence.id;
      axios
        .get(api)
        .then((res) => {
          if (
            self.occurrenceSelected &&
            self.occurrenceSelected.id === self.selectedOutcomeOccurrence.id
          ) {
            self.$set(self.occurrenceSelected, "outcome", res.data);
          }
          const idx = self.occurrences.findIndex(
            (o) => o.id === self.selectedOutcomeOccurrence.id
          );
          if (idx !== -1) self.$set(self.occurrences[idx], "outcome", res.data);
        })
        .finally(() => {
          self.selectedOutcomeOccurrence = null;
        });
    },
    formatBool(val) {
      if (val === null || val === undefined) return "—";
      return val ? "Sim" : "Não";
    },
    getCentrals: function () {
      const self = this;
      const api = self.$store.state.api + "centrals?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.centrals = response.data.data.sort((a, b) =>
            a.name.localeCompare(b.name)
          );
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted() {
    // Preenche filtros a partir dos query params, se existirem
    const query = this.$route.query;
    if (query) {
      if (query.data_inicio) this.filters.opening_date = query.data_inicio;
      if (query.data_fim) this.filters.end_date = query.data_fim;
    }
    this.getOccurrences();
    this.getUnits();
    this.getCentrals();
    this.getMedicals();

    if (this.selectedOccurrenceId) {
      window.Echo.private("new_status." + this.selectedOccurrenceId).listen(
        ".Status",
        (e) => {
          console.log("Evento recebido:", e);
        }
      );
    }

    const userId = this.$store.state.user && this.$store.state.user.usuario_id;
    if (userId && window.Echo) {
      window.Echo.private(`private-user.${userId}`).listen(
        ".export.ready",
        (e) => this.onExportReady(e)
      );
    }
  },

  beforeDestroy() {
    this.stopExportPolling();
    const userId = this.$store.state.user && this.$store.state.user.usuario_id;
    if (userId && window.Echo) {
      window.Echo.private(`private-user.${userId}`).stopListening(
        ".export.ready"
      );
    }
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}

.main-content {
  padding: 20px;
}

.table th,
.table td {
  text-align: center;
}
</style>
